<script setup lang="ts">
import { onClickOutside } from '@vueuse/core';
import { ref } from 'vue';

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  x: {
    type: String
  },
  y: {
    type: String
  },
  nestedPopups: {
    type: Boolean
  }
});

const target = ref(null);

const emit = defineEmits(['outsidePopupClick']);

const toggle = (event: PointerEvent) => {
  if (target.value && props.nestedPopups) {
    const targetBounds = (target.value as HTMLElement).getBoundingClientRect();

    const elementBounds = (event.target as HTMLElement).getBoundingClientRect();

    const targetXEnd = targetBounds.x + targetBounds.width;
    const targetXStart = targetBounds.x ;

    const elementX = event.clientX;

    const elementXStart = elementBounds.x;
    const elementXEnd = elementBounds.x + elementBounds.width;

    if (elementXStart > targetXStart && elementXStart < targetXEnd) {
      if (!(elementX > elementXStart && elementX < elementXEnd)) {
        emit('outsidePopupClick');
      }
    } else {
      emit('outsidePopupClick');
    }
  } else {
    emit('outsidePopupClick');
  }
};

onClickOutside(target, toggle);

defineExpose({
  target
});
</script>

<template>
    <teleport to="body">
      <div class="popup" ref="target" v-if="visible">
          <slot name="popupContent"></slot>
      </div>
    </teleport>
</template>

<style scoped>
.popup {
  padding: 0;
  margin: 0;
  position: absolute;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 5px 5px -3px hsla(0, 0%, 0%, 0.2),
    0px 8px 10px 1px hsla(0, 0%, 0%, 0.14),
    0px 3px 14px 2px hsla(0, 0%, 0%, 0.12);
  left: v-bind(x);
  top: v-bind(y);
  z-index: 10;
}
</style>
